// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `motes-map #map {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
}
motes-map .fakeMap {
  background-image: url('map.png');
  background-position-x: center;
  background-position-y: bottom;
  background-repeat: no-repeat;
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/motes-map/motes-map.component.scss"],"names":[],"mappings":"AAEI;EACI,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;AADR;AAII;EACI,gCAAA;EACA,6BAAA;EACA,6BAAA;EACA,4BAAA;AAFR","sourcesContent":["motes-map {\n\n    #map {\n        position: absolute;\n        top: 0;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        z-index: 1;\n    }\n\n    .fakeMap {\n        background-image: url('./map.png');\n        background-position-x: center;\n        background-position-y: bottom;\n        background-repeat: no-repeat;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
